import { Link } from "wouter";
import wordmarkInkDot from "@assets/clarik-wordmark-ink-dot_1779992771228.png";
import wordmarkPaperDot from "@assets/clarik-wordmark-paper-dot_1779992771228.png";

/**
 * Clarik marketing chrome — see docs/brand-guidelines.md.
 * Light mode: clarik-wordmark-ink-dot · Dark mode: clarik-wordmark-paper-dot
 * All-lowercase. The dot on the i is forest green. Nav: Product / Pricing / About / Sign in.
 */
export function ClarikWordmark({ className = "" }: { className?: string }) {
  return (
    <span className={`inline-flex items-center ${className}`}>
      <img
        src={wordmarkInkDot}
        alt="Clarik"
        className="h-[1.1em] w-auto dark:hidden"
        data-testid="clarik-wordmark-light"
      />
      <img
        src={wordmarkPaperDot}
        alt="Clarik"
        className="h-[1.1em] w-auto hidden dark:block"
        data-testid="clarik-wordmark-dark"
      />
    </span>
  );
}

export function MarketingNav() {
  return (
    <nav
      className="border-b border-[hsl(var(--fog))] dark:border-[hsl(var(--ink-soft))] bg-[hsl(var(--paper))] dark:bg-[hsl(var(--ink))]"
      data-testid="marketing-nav"
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link href="/" className="text-lg" data-testid="link-marketing-home">
          <ClarikWordmark />
        </Link>
        <div className="flex items-center gap-6 text-sm">
          <Link href="/marketing/features" className="hover:text-[hsl(var(--green))]" data-testid="link-marketing-features">Product</Link>
          <Link href="/pricing" className="hover:text-[hsl(var(--green))]" data-testid="link-marketing-pricing">Pricing</Link>
          <Link href="/marketing/about" className="hover:text-[hsl(var(--green))]" data-testid="link-marketing-about">About</Link>
          <a
            href="/login"
            className="text-[hsl(var(--green))] hover:underline underline-offset-4"
            data-testid="link-marketing-login"
          >
            Sign in
          </a>
        </div>
      </div>
    </nav>
  );
}

export function MarketingFooter() {
  return (
    <footer
      className="border-t border-[hsl(var(--fog))] dark:border-[hsl(var(--ink-soft))] mt-16 bg-[hsl(var(--paper))] dark:bg-[hsl(var(--ink))]"
      data-testid="marketing-footer"
    >
      <div className="max-w-6xl mx-auto px-6 py-8 text-xs text-[hsl(var(--graphite))] flex flex-wrap justify-between gap-3">
        <span className="flex items-center gap-2 text-sm">
          <ClarikWordmark />
          <span className="text-[hsl(var(--graphite))]">© {new Date().getFullYear()}</span>
        </span>
        <span className="flex gap-5">
          <Link href="/pricing" className="hover:underline">Pricing</Link>
          <Link href="/marketing/features" className="hover:underline">Product</Link>
          <Link href="/marketing/about" className="hover:underline">About</Link>
          <Link href="/terms" className="hover:underline">Terms</Link>
          <Link href="/privacy" className="hover:underline">Privacy</Link>
        </span>
      </div>
    </footer>
  );
}
